module.exports = __webpack_public_path__ + "img/slide4.0de838e7.png";